import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const HomeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.32336 6.04464C2.11729 6.23401 2 6.50108 2 6.78096V14.8643C2 15.1404 2.22386 15.3643 2.5 15.3643H5.5C5.77614 15.3643 6 15.1404 6 14.8643V11.3493C6 10.2447 6.89543 9.34927 8 9.34927C9.10457 9.34927 10 10.2447 10 11.3493V14.8643C10 15.1404 10.2239 15.3643 10.5 15.3643H13.5C13.7761 15.3643 14 15.1404 14 14.8643V6.78096C14 6.50108 13.8827 6.23401 13.6766 6.04464L9.01496 1.76079C8.44108 1.23342 7.55892 1.23342 6.98504 1.76079L2.32336 6.04464Z"
		/>
	</svg>
))
